// src/config/api.config.js
// API Configuration
const config = {
    // Base URL
    apiUrl: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development'
        ? 'http://localhost:5000/api'
        : 'https://api.tympayservices.com/api'),
    // apiUrl: process.env.REACT_APP_API_URL || 'https://api.tympayservices.com/api',
    // Tym@2026Secure#91

    // Environment
    env: process.env.REACT_APP_ENV || 'development',

    // App Name
    appName: process.env.REACT_APP_APP_NAME || 'SHOPMART',

    // Client URL
    clientUrl: process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000',

    // API Endpoints
    endpoints: {
        publicBanners: '/banners',
        // ==================== AUTH (Client) ====================
        register: '/auth/register',
        login: '/auth/login',
        logout: '/auth/logout',
        refreshToken: '/auth/refresh-token',
        forgotPassword: '/auth/forgot-password',
        resetPassword: '/auth/reset-password/:token',
        verifyEmail: '/auth/verify-email/:token',
        validateReferral: '/auth/validate-referral/:code',
        referralInfo: '/auth/referral-info',
        changePassword: '/auth/change-password',

        // ==================== USER (Client) ====================
        profile: '/users/profile',
        updateProfile: '/users/profile',
        addresses: '/users/addresses',
        defaultAddress: '/users/addresses/default',
        wishlist: '/users/wishlist',

        // ==================== CART (Client) ====================
        cart: '/cart',
        cartItems: '/cart/items',
        applyCoupon: '/cart/apply-coupon',
        removeCoupon: '/cart/remove-coupon',

        // ==================== PRODUCTS (Shared) ====================
        products: '/products',
        productById: '/products/:id',
        productBySlug: '/products/slug/:slug',
        relatedProducts: '/products/:id/related',
        sellerProducts: '/products/seller/me',

        // ==================== CATEGORIES (Shared) ====================
        categories: '/categories',
        categoryProducts: '/categories/:id/products',

        // ==================== ORDERS (Client) ====================
        orders: '/orders',
        orderById: '/orders/:id',
        orderByNumber: '/orders/number/:orderNumber',
        cancelOrder: '/orders/:id/cancel',

        // ==================== PAYMENTS (Client) ====================
        createPaymentIntent: '/payments/create-intent',
        confirmPayment: '/payments/confirm',
        paymentStatus: '/payments/:id',

        // ==================== REVIEWS (Shared) ====================
        reviews: '/reviews',
        productReviews: '/reviews/product/:productId',
        reviewHelpful: '/reviews/:id/helpful',
        reviewNotHelpful: '/reviews/:id/not-helpful',
        reviewReport: '/reviews/:id/report',
        reviewReply: '/reviews/:id/reply',
        sellerReviews: '/reviews/seller',

        // ==================== SUPER ADMIN (Admin) ====================
        createAdmin: '/admin/super/users/create-admin',
        allUsers: '/admin/super/users',
        userDetails: '/admin/super/users/:id',
        blockUser: '/admin/super/users/:id/block',
        allStores: '/admin/super/stores',
        verifyStore: '/admin/super/stores/:id/verify',
        platformStats: '/admin/super/stats',

        // ==================== ADMIN PRODUCT MANAGEMENT ====================
        adminProducts: '/admin/products',
        adminProductsAll: '/admin/products',
        adminProductsPending: '/admin/products/pending',
        adminProductToggleStatus: '/admin/products/:id/toggle-status',
        adminProductApprove: '/admin/products/:id/approve',
        adminProductReject: '/admin/products/:id/reject',
        adminProductDelete: '/admin/products/:id',

        // ==================== ADMIN ORDER MANAGEMENT ====================
        adminOrders: '/admin/orders',
        adminOrdersAll: '/admin/orders',
        adminOrdersPending: '/admin/orders/pending',
        adminOrderUpdateStatus: '/admin/orders/:id/status',

        // ==================== ADMIN REFUND MANAGEMENT ====================
        adminRefunds: '/admin/refunds',
        adminRefundProcess: '/admin/refunds/:id/process',

        // ==================== ADMIN PAYOUT MANAGEMENT ====================
        adminPayouts: '/admin/payouts',
        adminPayoutProcess: '/admin/payouts/:id/process',
        adminPayoutsExport: '/admin/payouts/export',

        // ==================== ADMIN COMMISSION MANAGEMENT ====================
        adminCommission: '/admin/commission',
        adminCommissionGlobal: '/admin/commission/global',
        adminCommissionSeller: '/admin/commission/seller/:id',

        // ==================== ADMIN ANALYTICS ====================
        adminAnalytics: '/admin/analytics',

        // ==================== ADMIN BANNER MANAGEMENT ====================
        adminBanners: '/admin/banners',
        adminBannerCreate: '/admin/banners',
        adminBannerUpdate: '/admin/banners/:id',
        adminBannerDelete: '/admin/banners/:id',
        adminBannerToggle: '/admin/banners/:id/toggle',

        // ==================== ADMIN COUPON MANAGEMENT ====================
        adminCoupons: '/admin/coupons',
        adminCouponCreate: '/admin/coupons',
        adminCouponUpdate: '/admin/coupons/:id',
        adminCouponDelete: '/admin/coupons/:id',
        adminCouponStats: '/admin/coupons/:id/stats',

        // ==================== ADMIN TAX MANAGEMENT ====================
        adminTaxes: '/admin/taxes',
        adminTaxSettings: '/admin/taxes',

        // ==================== ADMIN SETTINGS ====================
        adminSettings: '/admin/settings',
        adminPlatformSettings: '/admin/settings',

        // ==================== ADMIN TRANSACTIONS ====================
        adminTransactions: '/admin/transactions',
        adminTransactionsExport: '/admin/transactions/export',

        // ==================== ADMIN DELIVERY CHARGES ====================
        adminDeliveryCharges: '/admin/delivery-charges',

        // ==================== SELLER (Store Admin) ====================
        registerStore: '/admin/register-store',
        storeDashboard: '/admin/store/dashboard',
        storeProfile: '/admin/store/profile',
        storeOrders: '/admin/store/orders',
        updateStoreOrder: '/admin/store/orders/:id/status',

        // ==================== SELLER ORDERS (Alternative API) ====================
        sellerOrders: '/orders/seller',
        sellerUpdateOrderStatus: '/orders/seller/:id/status',

        // ==================== OFFERS (Seller) ====================
        offers: '/offers',
        sellerOffers: '/offers/seller',
        offerById: '/offers/:id',
        toggleOffer: '/offers/:id/toggle',
        validateOffer: '/offers/validate',

        // ==================== CUSTOMERS (Seller) ====================
        sellerCustomers: '/orders/customers',
        exportCustomers: '/orders/customers/export',

        // ==================== PAYMENTS (Seller) ====================
        sellerPayments: '/payments/seller',
        withdrawRequest: '/payments/withdraw-request',

        // ==================== ANALYTICS (Seller) ====================
        sellerAnalytics: '/analytics/seller',

        // ==================== SETTINGS (Seller) ====================
        sellerSettings: '/seller/settings',
        storeSettings: '/seller/store-settings',

        // ==================== SELLER PRODUCTS ====================
        sellerAddProduct: '/products',
        sellerUpdateProduct: '/products/:id',
        sellerDeleteProduct: '/products/:id',
        sellerUpdateStock: '/products/:id/stock',

        // ==================== SELLER DASHBOARD ====================
        sellerDashboardStats: '/seller/dashboard/stats',
        sellerRecentOrders: '/seller/dashboard/recent-orders',
        sellerTopProducts: '/seller/dashboard/top-products',
    }
};

export default config;